import { SVGProps } from "react";

export default function YouTubeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, stroke = "#E2E2E2", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17 20H7C4 20 2 18 2 15V9C2 6 4 4 7 4H17C20 4 22 6 22 9V15C22 18 20 20 17 20Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3996 9.49981L13.8996 10.9998C14.7996 11.5998 14.7996 12.4998 13.8996 13.0998L11.3996 14.5998C10.3996 15.1998 9.59961 14.6998 9.59961 13.5998V10.5998C9.59961 9.29981 10.3996 8.89981 11.3996 9.49981Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
